<template>
  <legend
    :class="legendClasses"
    :data-cy="props.name ? `ds-legend--${props.name}` : 'ds-legend'"
  >
    <DSIcon
      v-if="props.icon"
      :icon="props.icon"
      size="sm"
    />
    <DSLabelContent
      :label="props.label"
      :required="props.required"
      :tooltip="props.tooltip"
      :hidden-label="props.hiddenLabel"
    >
      <template
        v-if="showsInlineEditIcon"
        #suffix
      >
        <DSIcon
          icon="pencil"
          :size="DS_ICON_SIZES.Small"
        />
      </template>
    </DSLabelContent>
  </legend>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { DS_LABEL_CLASSES } from "@/src/design_system/form_elements/label/constants/classes";
import { useStateClasses } from "@/src/design_system/shared/composables/useStateClasses";
import DSLabelContent from "../../label/components/DSLabelContent.vue";
import { DS_FIELDSET_CLASSES } from "@/src/design_system/form_elements/fieldset/constants/classes";
import DSIcon from "@/src/design_system/primitives/icon/components/DSIcon.vue";
import { DS_ICON_SIZES } from "@/src/design_system/primitives/icon/types";
import { DS_STATE_CLASSES } from "@/src/design_system/shared/constants/stateClasses";
import { DSLegendProps } from "@/src/design_system/form_elements/fieldset/types/props";

const props = withDefaults(defineProps<DSLegendProps>(), {
  name: undefined,
  required: false,
  hasError: false,
  inlineEdit: false,
  tooltip: undefined,
  withDivider: true,
  icon: undefined,
  hiddenLabel: false,
});

const { stateClasses } = useStateClasses(props);
const showsInlineEditIcon = computed(() => props.inlineEdit && !props.disabled);

const legendClasses = computed(() => ({
  [DS_LABEL_CLASSES.Root]: true,
  [DS_FIELDSET_CLASSES.Legend]: true,
  [DS_STATE_CLASSES.InlineEdit]: props.inlineEdit,
  [DS_LABEL_CLASSES.WithTooltip]: Boolean(props.tooltip?.trim()),
  ...stateClasses.value,
  [DS_LABEL_CLASSES.WithDivider]: props.withDivider,
}));
</script>
